export default __webpack_public_path__ + "static/media/sanmar18.043bdf30.jpg";